var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{staticClass:"show",attrs:{"fixed":"","background-color":_vm.color,"dark":"","shift":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-btn',{attrs:{"to":{
      name: 'homestore',
    }}},[_c('span',[_vm._v("خانه")]),_c('v-icon',[_vm._v("mdi-home")])],1),_c('v-btn',{attrs:{"to":{
      name: 'Home',
    }}},[_c('span',[_vm._v("غرفه ها")]),_c('v-icon',[_vm._v("mdi-store")])],1),_c('v-btn',{attrs:{"to":{
      name: 'aroundme',
    }}},[_c('span',[_vm._v("اطراف من")]),_c('v-icon',[_vm._v("mdi-google-maps")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }